import { c as _c } from "react/compiler-runtime";
import { IconNowBubble, MyMenuFixOn } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import type React from 'react';
import { useContext } from 'react';
import type { F_Select } from '../AfterItem';
import { AllMenuContainer } from './all/AllMenuContainer';
import MenuContext from './all/MenuContext';
import { menuSvg } from './all/menuSvg';
export function FavoriteMenu() {
  const $ = _c(15);
  const {
    navigateHandler,
    selectList,
    setSelectList,
    isAdult,
    userInfo
  } = useContext(MenuContext);
  let t0;
  if ($[0] !== selectList || $[1] !== setSelectList) {
    t0 = (e, item) => {
      e.stopPropagation();
      const result = selectList.filter(f => f.title !== item.title);
      setSelectList(result);
    };
    $[0] = selectList;
    $[1] = setSelectList;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const deleteHandler = t0;
  if (!isAdult) {
    return;
  }
  let t1;
  if ($[3] !== selectList.length) {
    t1 = selectList.length > 0 && <div className="bg-colorBg23 px-[10px] py-1 text-left text-[#777] text-[13px] leading-normal tracking-[-0.33px]">즐겨찾는 메뉴</div>;
    $[3] = selectList.length;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== deleteHandler || $[6] !== navigateHandler || $[7] !== selectList || $[8] !== userInfo?.vipSignatureInfo?.highlight) {
    t2 = selectList?.map((item_0, i) => <div className="item" key={i + item_0.title}><DropdownMenuItem className="px-1.5 text-box" onClick={() => navigateHandler(item_0)}><div className="w-5 ">{menuSvg[item_0.img]}</div><div>{item_0.title}</div></DropdownMenuItem>{userInfo?.vipSignatureInfo?.highlight === "Y" && item_0.url === "/my/signatureUser" && <IconNowBubble />}<div className="favorites-icon" onClick={e_0 => deleteHandler(e_0, item_0)}><MyMenuFixOn /></div></div>);
    $[5] = deleteHandler;
    $[6] = navigateHandler;
    $[7] = selectList;
    $[8] = userInfo?.vipSignatureInfo?.highlight;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <AllMenuContainer title="" isFavorite={true}><>{t2}</></AllMenuContainer>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = <div className="w-full">{t1}{t3}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}